export default {
    setSources(state, payload) {
        state.source = payload;
    },
    setWorkspaceSources(state, payload) {
        state.workspaceSources = payload;
    }
}